import { isBefore, subHours } from 'date-fns'

import type { Appointment } from '../types/appointment.types'

const CANCEL_DEADLINE_HOURS = 72

/**
 * Whether the patient may still cancel: the agenda allows it, it is not cancelled already, and the
 * start is further away than the deadline. Inside the deadline the screen points to the
 * secretariat instead.
 */
function canCancelAppointment(appointment: Appointment, now: Date = new Date()): boolean {
  if (appointment.meta.cancellable === false || appointment.status === 'cancelled') {
    return false
  }

  return isBefore(now, subHours(new Date(appointment.start), CANCEL_DEADLINE_HOURS))
}

export { canCancelAppointment }
